const OurBusinessScreen = () => {
    
    return(
        <p>Our Business</p>
    )
}

export default OurBusinessScreen